<template>
	<div>
		<v-layout v-if="$route.name === 'ledger'" wrap align-center justify-space-between class="journal-detail" py-3>
			<v-flex  xs4 sm6 md3>
				<v-layout wrap align-center justify-center class="should-color">
					<v-flex>
						<div font-weight-bold class="d-flex px-0 justify-center">
							<span class="debitV">DEBE: {{ debit || 0 | formatAmount }}</span>
						</div>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs4 sm6 md4>
				<v-layout wrap align-center justify-center class="to-have-color">
					<v-flex>
						<div font-weight-bold class="d-flex px-3 justify-end">
							<span class="debitC">HABER: {{ credit || 0 | formatAmount }}</span>
						</div>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs4 sm6 md4>
				<v-layout wrap align-center class="content-gray">
					<v-flex>
						<div font-weight-bold class="d-flex px-3 justify-end">
							<span class="debitB">SALDO: {{ balance || 0 | formatAmount }}</span>
						</div>
					</v-flex>
				</v-layout>
			</v-flex>
		</v-layout>
		<v-layout v-else wrap align-center justify-end class="journal-detail">
			<v-flex xs6 sm6 md3>
				<v-layout wrap align-center justify-center class="should-color">
					<v-flex>
						<div class="d-flex justify-center">
						<span class="debitV">DEBE: {{ debit || 0 | formatAmount }}</span>
						</div>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs6  md3 sm6>
				<v-layout wrap align-center justify-center class="to-have-color" ml-2 >
					<v-flex>
						<div class="d-flex justify-center">
						<span class="debitC">HABER: {{ credit || 0 | formatAmount }}</span>
						</div>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs6  md3 sm6>
	<v-layout wrap align-center justify-center class="content-gray" ml-2 >
		<v-flex>
			<div class="d-flex justify-center">
			<span class="debitB">	SALDO: {{ balance || 0 | formatAmount }}</span>
			</div>
		</v-flex>
	</v-layout>
</v-flex>
			<v-flex v-if="balance !== 0 "  xs2 sm3 md3 class="to-no-declared">
				Asiento no cuadrado
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
	export default {
		name: 'journal-detail-balance',
		props: {
			balance: {
				default: 0,
				type: Number,
			},
			credit: {
				default: 0,
				type: Number,
			},
			debit: {
				default: 0,
				type: Number,
			},
			toDeclare: {
				type: Boolean,
				default: false,
			},
			notDeclare: {
				type: Boolean,
				default: false,
			},
		},
	};
</script>

<style lang="scss" scoped>
	.v-subheader {
		height: 33px;
	}

	.journal-detail {
		border-radius: 0 0 10px 10px;
		font-size: 14px;
		display: flex;
		justify-content: center; // Centrado horizontal.
		align-items: center; 
		@media (max-width: 768px) {
			@include flex-center;
			max-width: 1200px;
			margin: 0 auto;
			display: grid;
			align-text: center;
			gap: 0.2rem;
		}
	}

	.should-color {
		opacity:0.8;
		background-color: #02979b ;
		border-radius: 10px;
		width: auto;
		height: 31px;
		@media (max-width: 768px) {
			font-size: 11px;
			width: 194px;
		}
		.debitV {
			width: 174px;
			height: 20px;
			font-family: 'AvenirRegular';
			font-size: 14px;
			font-weight: bold;
			font-stretch: normal;
			font-style: normal;
			line-height: 1.54;
			letter-spacing: normal;
			text-align: center;
			color: white;
		}
	}

	.to-have-color {
		opacity: 0.8;
		background-color: color(secondary);
		border-radius: 10px;
		height: 31px;
		width: auto;
		@media (max-width: 768px) {
			font-size: 11px;
			width: 194px;
		}
		.debitC {
			width: 174px;
			height: 20px;
			font-family: 'AvenirRegular';
			font-size: 14px;
			font-weight: bold;
			font-stretch: normal;
			font-style: normal;
			line-height: 1.54;
			letter-spacing: normal;
			text-align: center;
			color: white;
		}
	}

	.to-no-declared {
		width: 120px;
		border-bottom-right-radius: 10px;
		color: map-get($colors, error);
		font-family: map-get($fonts, AvenirRegular);
		font-size: 10px;
		font-weight: 600; // Aplica semibold
		padding: 4px 17px;
		text-align: center;
	}

	.content-gray {
		background-color: #77a1d1;
		border-radius: 10px;
		color: map-get($colors, white);
		height: 31px;
		width: auto;
		@media (max-width: 768px) {
			font-size: 11px;
			width: 194px;
		}
		.debitB {
			width: 174px;
			height: 20px;
			font-family: 'AvenirRegular';
			font-size: 14px;
			font-weight: bold;
			font-stretch: normal;
			font-style: normal;
			line-height: 1.54;
			letter-spacing: normal;
			text-align: center;
			color: white;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/journal/journal-detail-balance.vue